export const MESSAGE_TYPE = {
  'text': 0,
  'contact': 1
}

export const ATTACHMENT_TYPE = {
  'audio': 1,
  'photo': 2,
  'video': 3,
  'file': 4
}

export const SAYHOLA_BLOG_ID = '9FF9HxvyTgi7fkASaUPy3L'
export const AFFILIATE_BLOG_ID = 'qYbBkyPawCYqd7iYH4y7sC'

export const SERVICE_PHONES_LIST = ['+17775550000']

export const LOCALES = {
  'en': 'English',
  'ja': '日本語',
  'ru': 'Русский',
  'es': 'Español',
  'zh-hans': '简体中文',
  'pt': 'Português',
  'fr': 'Français',
  'de': 'Deutsch'
}
